import { Component, Input, OnInit } from '@angular/core';

import { SelectOptionService } from 'src/app/shared-data/select-option.service';
import { CheckoutStateService } from 'src/app/shared-data/checkout-state.service';
import { Utils } from 'src/app/utils/utilities';
import { ZipYiElement } from '~services/biocatch/zip-yi-element.enum';

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
})
export class SelectOptionComponent implements OnInit {
  @Input() public dataGiftCard: any;
  @Input() public dataOptions: any;
  @Input() public titleSelectOption: any;
  public customAmountValue: any;
  public minCustomPrice: any;
  public maxCustomPrice: any;
  public dataSelected: any;
  public isFocused: boolean;
  public hideDenominations: boolean;
  zipYiElement = ZipYiElement;

  constructor(
    public selectOptionService: SelectOptionService,
    public checkoutStateService: CheckoutStateService,
  ) {}

  ngOnInit() {
    this.dataSelected = '';
    this.hideDenominations = false;
    this.customAmountValue = '';
    this.isFocused = false;
    this.setDataGiftCard(this.dataGiftCard);
  }

  setDataOptions(value) {
    this.selectOptionService.dataOptions = [...value];

    if (Utils.checkValid(this.selectOptionService.dataGiftCard.customDenominations)) {
      let objCustomPrice: any = {};
      objCustomPrice.price = 'custom';
      objCustomPrice.currency = 'AUD';
      objCustomPrice.stock = 'IN_STOCK';

      if (this.selectOptionService.dataOptions.length === 0) {
        this.dataSelected = 'custom';
        this.hideDenominations = true;
      }

      this.selectOptionService.dataOptions.unshift(objCustomPrice);

      this.setRangeCustomPrice();
    }
    this.setDefaultValueDataSelected();
    this.setSelectedDataOptions(this.dataSelected);
  }

  setDataGiftCard(value) {
    this.selectOptionService.dataGiftCard = { ...value };

    this.setDataOptions(this.dataOptions);
  }

  setRangeCustomPrice() {
    this.minCustomPrice = this.selectOptionService.dataGiftCard.customDenominations[0].minPrice;
    this.maxCustomPrice = this.selectOptionService.dataGiftCard.customDenominations[0].maxPrice;
  }

  setDefaultValueDataSelected() {
    for (let i = 0; i < this.selectOptionService.dataOptions.length; i++) {
      let priceTmp = this.selectOptionService.dataOptions[i].price;
      let stockTmp = this.selectOptionService.dataOptions[i].stock;

      if (Number(priceTmp) > 0 && stockTmp === 'IN_STOCK') {
        this.dataSelected = priceTmp;
        break;
      }
    }

    this.selectOptionService.setDataSelectedCustomValue(this.dataSelected);
  }

  toggleDropdown(event) {
    if (!this.checkoutStateService.isCheckoutBtnTriggered) {
      let dropdownWrapper = event.target.parentNode;

      dropdownWrapper.classList.toggle('is-expanded');
    }
  }

  doSelectValueOption(event, dataOption) {
    this.selectOptionService.isValidData = true;
    this.selectOptionService.isValidCustomAmount = true;
    this.selectOptionService.isCustomAmount = false;
    this.customAmountValue = '';

    if (dataOption.stock === 'IN_STOCK') {
      let dropdownWrapper = event.target.closest('.select-option-wrapper');

      dropdownWrapper.classList.remove('is-expanded');
      this.dataSelected = dataOption.price;
      this.selectOptionService.setDataSelectedCustomValue(this.dataSelected);

      this.setSelectedDataOptions(this.dataSelected);
    }
  }

  closeDropdown(event) {
    let dropdownWrapper = event.target.parentNode;

    dropdownWrapper.classList.remove('is-expanded');
  }

  changeCustomAmount(event) {
    this.selectOptionService.isValidData = true;
    this.selectOptionService.isValidCustomAmount = true;
    this.selectOptionService.isCustomAmount = true;

    if (
      (Number(this.customAmountValue) < Number(this.minCustomPrice) &&
        Utils.checkValid(this.customAmountValue)) ||
      (Number(this.customAmountValue) > Number(this.maxCustomPrice) &&
        Utils.checkValid(this.customAmountValue))
    ) {
      this.selectOptionService.isValidCustomAmount = false;
    }
  }

  handleFocusInputCustomAmount(event) {
    this.isFocused = true;
    this.selectOptionService.isValidData = true;
    this.selectOptionService.isValidCustomAmount = true;

    this.customAmountValue = this.customAmountValue.replace('$', '');
  }

  handleOutFocusInputCustomAmount(event) {
    this.isFocused = false;

    if (Utils.checkValid(this.customAmountValue)) {
      if (
        Number(this.customAmountValue) < Number(this.minCustomPrice) ||
        Number(this.customAmountValue) > Number(this.maxCustomPrice)
      ) {
        this.selectOptionService.isValidCustomAmount = false;
      }

      this.customAmountValue = '$' + this.customAmountValue;
      this.selectOptionService.isCustomAmount = true;
    }

    this.selectOptionService.setDataSelectedCustomValue(this.customAmountValue);
  }

  handleInputChangeCustomAmount(event) {
    if (Utils.checkValid(this.customAmountValue)) {
      if (
        Number(this.customAmountValue) < Number(this.minCustomPrice) ||
        Number(this.customAmountValue) > Number(this.maxCustomPrice)
      ) {
        this.selectOptionService.setDataSelectedCustomValue('');
      } else {
        this.selectOptionService.setDataSelectedCustomValue(this.customAmountValue);
      }
    } else {
      this.selectOptionService.setDataSelectedCustomValue('');
    }
  }

  setSelectedDataOptions(value) {
    this.selectOptionService.dataOptions.forEach((option) => {
      if (option.price === value) {
        option.isSelected = true;
      } else {
        option.isSelected = false;
      }
    });
  }
}
